import { useState } from "react";
import type { ParentFormErrors, ParentFormField, ParentFormValues } from "../types";
import { defaultParentFormValues } from "../utils/parentFormMapping";

export const useParentForm = (initialValues: ParentFormValues = defaultParentFormValues) => {
  const [values, setValues] = useState<ParentFormValues>(initialValues);
  const [errors, setErrors] = useState<ParentFormErrors>({});

  const updateField = (field: ParentFormField, value: string | boolean) => {
    setValues((current) => ({ ...current, [field]: value }));
    setErrors((current) => {
      if (!current[field]) return current;
      const next = { ...current };
      delete next[field];
      return next;
    });
  };

  return {
    values,
    setValues,
    errors,
    setErrors,
    updateField,
  };
};
